<div id="logout-page-content">
  <app-spinner></app-spinner>
</div>
